import React, { useState } from 'react';
import { FaCommentDots } from 'react-icons/fa';
import ChatLogic from './ChatLogic';
import './ChatbotMini.css';

const ChatbotMini = () => {
    const [isChatOpen, setIsChatOpen] = useState(true); // Manage open/close state here

    const toggleChat = () => setIsChatOpen(!isChatOpen); // Function to toggle chat

    return (
        <div className={`chatbot-mini ${isChatOpen ? 'open' : ''}`}>
            <button className="toggle-chat" onClick={toggleChat}>
                <FaCommentDots />
            </button>
            {isChatOpen && <ChatLogic isChatOpen={isChatOpen} />}
        </div>
    );
};

export default ChatbotMini;